import PropTypes from 'prop-types'

import styles from './Dropdown.module.scss'

const Dropdown = ({
  label,
  className,
  valid,
  options = {},
  defaultVal,
  forwardedRef,
  value,
  isSortedAlphabetically = true,
  ...props
}) => {
  return (
    <label className={[styles.container, className].join(' ')}>
      {label && <span className={styles.label}>{label}</span>}
      <select
        ref={forwardedRef}
        className={[
          styles.select,
          valid === true ? styles.selectSuccess : '',
          valid === false ? styles.selectError : ''
        ].join(' ')}
        value={value || defaultVal}
        {...props}
      >
        {defaultVal && (
          <option value={null} disabled>
            {defaultVal}
          </option>
        )}
        {Object.keys(options)
          .sort((a, b) =>
            isSortedAlphabetically
              ? options[a] < options[b]
                ? -1
                : options[a] > options[b]
                ? 1
                : 0
              : 1
          )
          .map(k => (
            <option key={label + k} value={k}>
              {options[k]}
            </option>
          ))}
      </select>
    </label>
  )
}

Dropdown.propTypes = {
  options: PropTypes.object,
  defaultVal: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  succeded: PropTypes.bool,
  errored: PropTypes.bool,
  value: PropTypes.string
}

export default Dropdown
